import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';

import { BillingComponent } from './billing.component';
import { UsageComponent } from './usage/usage.component';
import { CreditCardComponent } from './credit-card/credit-card.component';
import { UpgradeOrDowngradeComponent } from './upgrade-or-downgrade/upgrade-or-downgrade.component';
import { OneTimeCreditsComponent } from './one-time-credits/one-time-credits.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { SubscriptionComponent } from './subscription/subscription.component';

import { BillingGuardService } from './billing-guard.service';
import { ClientRouteResolve } from '../../../providers/client-route-resolve.service';

import { routing } from './billing.routing';


export class BillingModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/billing.module.ts